module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Create new":"Neu anlegen","Show filters":"Filter anzeigen","Hide filters":"Filter verbergen","List could not be fetched.":"Liste konnte nicht abgerufen werden."}}')
  delete Component.options._Ctor
}
